import React, {Component} from 'react';
import {modifyBagsForm} from 'components/forms/decorators';
import modifyBagsOrderMutation from 'graphql/mutations/orders/modify-bags-order.gql';
import SectionBanner from 'components/section-banner';
import OrderHeader from 'components/order-header';
import ProductPicker from 'components/product-picker';
import AddressGrid from 'components/address-grid';
import {Form, Field, Textarea} from 'components/forms';
import Button from 'components/button';
import styles from '../styles.css';

@modifyBagsForm(modifyBagsOrderMutation, 'll_dealer_bags')
export default class LLDealerBagsModify extends Component {
    render() {
        const {orderData, addressesData, itemsData} = this.props;
        return (
            <div className={styles.root}>
                <SectionBanner />
                <Form
                    fields={[
                        {key: 'items',
                            initial: orderData.order.items.map(({referenceContentId, quantity}) => ({
                                item: referenceContentId,
                                quantity,
                            }))},
                        {key: 'notes', required: false, initial: orderData.order.extraData.notes},
                        {key: 'reason', required: false},
                        {key: 'address', initial: orderData.order.shippingAddress.id},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <div className={styles.modifyForm}>
                            <OrderHeader order={orderData.order} isModifying showStatus />
                            <ProductPicker
                                items={itemsData.bags}
                                perItemLimit={itemsData.perItemLimit}
                                toggleSelectedProduct={this.props.toggleSelectedProduct}
                                {...getFieldProps('items')}
                            />
                            {renderErrors('items')}
                            <Field label='Comentarios'>
                                <Textarea {...getFieldProps('notes')} />
                                {renderErrors('notes')}
                            </Field>
                            <Field label='Motivo de la modificación'>
                                <Textarea {...getFieldProps('reason')} />
                                {renderErrors('reason')}
                            </Field>
                            <Field label='Dirección de envío de los carteles'>
                                {orderData.order.shipments.some(shipment => shipment.status.id !== 'pending') && (
                                    <div>
                                        Advertencia: este pedido tiene Envíos cuyo estado está avanzado.
                                        Realice la modificación considerando esta situación.
                                    </div>
                                )}
                                <AddressGrid
                                    addresses={addressesData.addresses}
                                    disableCreation
                                    {...getFieldProps('address')}
                                />
                                {renderErrors('address')}
                            </Field>
                            {renderErrors('__all__')}
                            <Form.Actions>
                                <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                </Button>
                            </Form.Actions>
                        </div>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/lado-a-lado/dealer/bags/modify/index.js